import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import React from "react";

const DeleteNoteModal = ({ deleteModal, setDeleteModal, deleteHandler }) => {
  return (
    <Dialog
      style={{ zIndex: "9999999999" }}
      open={deleteModal?.is_open}
      onClose={() => null}
      as="div"
      className="fixed inset-0 z-10  my-auto flex flex-col items-center justify-center"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 my-auto bg-black opacity-40 " />
      <Dialog.Title />
      <Dialog.Description />
      <div className="z-[999999999999] flex  w-[90%] flex-col items-center justify-center rounded-xl bg-white p-4 text-center leading-tight md:w-[30%] md:p-6 ">
        <img
          urlEndpoint="https://img.learntube.ai/public-assets/"
          src="https://img.learntube.ai/public-assets/Ai%20notes/Group%2020386.svg?updatedAt=1715917611599"
          className="h-[150px] w-[150px]"
          transformation={[
            {
              height: "160",
              width: "160",
            },
          ]}
        />
        <div className="text-[20px] font-bold md:text-[28px]">Delete Note?</div>
        <div className="mt-2 text-[16px] text-[#8D8D8D] md:text-[20px]">
          Deleted note cannot be recovered.
        </div>
        <div className="mt-4 grid w-full grid-cols-2 gap-2 md:mt-6">
          <button
            className="cursor-pointer rounded-lg border-2 border-[#13B284] p-2 text-[16px] font-bold text-[#13B284] md:text-[20px]"
            onClick={(e) =>
              setDeleteModal((prev) => ({ ...prev, is_open: false }))
            }
          >
            No, Cancel
          </button>
          <button
            className=" cursor-pointer rounded-lg border-2 border-[#E06064] bg-[#E06064] p-2 text-[16px] font-bold text-white md:text-[20px]"
            onClick={(e) => {
              deleteHandler(deleteModal?.note);
            }}
          >
            Delete Note
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteNoteModal;
